export default __webpack_public_path__ + "static/media/farmerline-min.04ba49bc.webp";